module.exports = __webpack_public_path__ + "static/media/Julius.b3dcd403.svg";